import { POST } from "../../../APiHelper/API"

let source;
export const searchCupRefereeToAddAPICall = (cupId, term, onSuccess, onError) => {
    const data = {
        term: term
    }
    source = POST(`/api/v1/cups/${cupId}/search_referee_for_add`, data, onSuccess, onError, true, source)
}